export default {
  state: {
    prodSponsorInfo: null, // 申请商品赞助信息
    travelFundsInfo: null, // 旅游基金
    fansDiscountInfo: null // 粉丝专属优惠信息
  }
}
